import { Star, MessageSquare, Sparkles, MapPin } from "lucide-react";
import { business } from "@/config/business";
import { Reveal } from "@/components/Reveal";

const items = [
  { icon: Star, title: `${business.rating} ★ Google Rating`, sub: business.verifyLabel },
  { icon: MessageSquare, title: `${business.reviewCount} Reviews`, sub: business.verifyLabel },
  { icon: Sparkles, title: "Beauty • Hair • Grooming", sub: "All in one place" },
  { icon: MapPin, title: "Paldi Meena, Jaipur", sub: "Your local studio" },
];

export default function TrustBar() {
  return (
    <section aria-label="Highlights" className="border-y border-primary/10 bg-white" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-10 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {items.map((it, i) => (
          <Reveal key={it.title} delay={i * 0.08}>
            <div data-testid={`trust-item-${i}`} className="flex items-start gap-4">
              <it.icon size={22} className="text-accent shrink-0 mt-0.5" aria-hidden="true" />
              <div>
                <p className="font-semibold text-ink text-sm sm:text-base leading-snug">{it.title}</p>
                <p className="text-xs text-muted-foreground mt-1 uppercase tracking-wider">{it.sub}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
